import React from 'react';
import { Sparkles } from 'lucide-react';

export default function SuperheroCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('superhero-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-violet-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Sparkles className="w-12 h-12 text-violet-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Name Your Superhero Team?
        </h2>
        <p className="text-xl text-violet-100 mb-8">
          Join thousands of superhero teams who've found their perfect name with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-violet-600 text-lg px-8 py-4 rounded-lg hover:bg-violet-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          Create Your Team Name Now!
        </button>
        <p className="mt-6 text-sm text-violet-200">
          Perfect for comic creators, RPG players, and superhero enthusiasts
        </p>
      </div>
    </section>
  );
}